import React from "react";
import { Spin, Tag } from "antd";
import api from "../../../services/api";
import { data_venda, venda } from "../services/venda";
import moment from "moment";

export default class NotaFiscalTableRow extends React.Component {
  state = {
    parcela: null
  };

  componentDidMount = () => {
    const pagamento = this.props.pagamento;
    //console.log('ca_token', this.props.ca_token)
    this.getParcela(pagamento["Nr. Nota Fiscal"]);
    //console.log('pagamento', pagamento)
  };

  updateNotaFiscal = () => {
    const params = {
      data_conciliacao: moment().format("YYYY-MM-DD"),
      conta_azul: true,
      status: 1
    };
    const res = api.put(
      `/notafiscal/${this.props.pagamento["Nr. Nota Fiscal"]}/update/`,
      params
    );
    console.log(res);
  };

  getParcela = async numero_nf => {
    const res = await api.get(`/parcela/?notafiscal__numero_nf=${numero_nf}`);
    if (res.data.results.length > 0) {
      this.setState({ parcela: res.data.results[0] });
      this.updateNotaFiscal();
      this.setState({
        ...this.state,
        result: 1,
        sucesso: "Pagamento conciliado"
      });
    } else {
      this.setState({ erro: "Nota fiscal não encontrada no sistema." });
    }
  };

  render() {
    if (this.state.parcela == null)
      return (
        <React.Fragment>
          <tr>
            <td>{this.props.pagamento["Nr. Nota Fiscal"]}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              {"erro" in this.state ? (
                <Tag color="#f50">Erro</Tag>
              ) : (
                <Spin></Spin>
              )}
            </td>
            <td>{"erro" in this.state ? this.state.erro : <Spin></Spin>}</td>
          </tr>
        </React.Fragment>
      );
    else {
      return (
        <React.Fragment>
          <tr>
            <td>{this.props.pagamento["Nr. Nota Fiscal"]}</td>
            <td>{this.state.parcela.pasta}</td>
            <td>{this.state.parcela.tipo_acordo}</td>
            <td>{this.state.parcela.num_parcela}</td>
            <td>{this.state.parcela.valor_parcela}</td>
            <td>{this.state.parcela.valor_pago}</td>
            <td>{this.state.parcela.data_pagamento}</td>
            <td>{this.state.parcela.data_vencimento}</td>
            <td>{this.state.parcela.status_parcela}</td>
            <td>
              {"sucesso" in this.state ? (
                this.state.result == 1 ? (
                  <Tag color="#87d068">Ok</Tag>
                ) : (
                  <Tag color="#f50">Erro</Tag>
                )
              ) : (
                <Spin />
              )}
            </td>
            {"sucesso" in this.state ? <td>{this.state.sucesso}</td> : ""}
          </tr>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContaAzul/components/nota_fiscal.js